<template>
  <div
    v-loading="loading"
    element-loading-background="rgba(24, 33, 48, 0.8)"
    class="flex flex-col"
  >
    <el-form :disabled="isReadonly" label-position="top">
      <el-form-item label="ID">
        <el-input v-model="model.id" :disabled="Number(model.id)" />
      </el-form-item>
      <el-form-item label="Model Name">
        <el-input v-model="model.name" />
      </el-form-item>
      <el-form-item label="Description">
        <el-input
          type="textarea"
          class="w-full"
          :autosize="{ minRows: 3 }"
          placeholder="Provide context about why this event was correct/incorrect..."
          v-model="model.desc"
        />
      </el-form-item>
      <el-form-item label="">
        <div>Parameters</div>
        <ModelParamList v-model="model.paramList" />
      </el-form-item>
    </el-form>
    <div class="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
      <el-button @click="$emit('cancel')">Close</el-button>
      <el-button
        v-if="!isReadonly"
        type="primary"
        @click="handleSave"
        :loading="submitting"
      >
        {{ modelId ? "Save Model" : "Create Model" }}
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  getDashboardModelDetail,
  updateDashboardModel,
  createDashboardModel,
} from "@/api";

import ModelParamList from "@/components/ModelParamList.vue";

export default {
  name: "ModelEditDialog",
  components: {
    ModelParamList,
  },
  emits: ["confirm", "cancel"],
  props: {
    modelId: {
      type: [String, Object],
      default: null,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      model: {
        id: undefined,
        name: "",
        desc: "",
        paramList: [],
      },
    };
  },
  methods: {
    async fetchDataById(modelId) {
      if (!modelId) return;
      const me = this;
      me.loading = true;
      try {
        const res = await getDashboardModelDetail(modelId);
        me.model = res?.data || res;
      } finally {
        me.loading = false;
      }
    },
    async handleSave() {
      const me = this;
      me.submitting = true;
      try {
        if (me.modelId) {
          await updateDashboardModel(me.model);
        } else {
          // 新建模型接口未实现，如需支持请补充 createDashboardModel
          await createDashboardModel(me.model);
        }
        me.$emit("confirm", me.model);
      } finally {
        me.submitting = false;
      }
    },
  },
  mounted() {
    const me = this;
    if (me.modelId) {
      me.fetchDataById(me.modelId);
    }
  },
};
</script>
